 <template>
  <form @submit.prevent="submitForm" class="modal__form">
    <h2 class="modal__title center">{{ title }}</h2>

    <div class="form__group">
      <label for="name" class="form__label">{{ $t('form.name') }} *</label>
      <input
        type="text"
        id="name"
        v-model="formData.name"
        class="form__input"
        :class="{ 'input-error': errors.name }"
        :placeholder="errors.name ? $t('form.required') : ''"
        @focus="removeError('name')"
      />
    </div>

    <div class="form__group">
      <label for="email" class="form__label">{{ $t('form.email') }} *</label>
      <input
        type="text"
        id="email"
        v-model="formData.email"
        class="form__input"
        :class="{ 'input-error': errors.email }"
        :placeholder="errors.email ? $t('form.required') : ''"
        @focus="removeError('email')"
      />
    </div>

    <div class="form__group">
      <label for="phone" class="form__label">{{ $t('form.phone') }} *</label>
      <input
        type="text"
        id="phone"
        v-model="formData.phone"
        class="form__input"
        :class="{ 'input-error': errors.phone }"
        :placeholder="errors.phone ? $t('form.required') : ''"
        @focus="removeError('phone')"
        @input="formatPhone"
      />
    </div>

    <div class="form__group">
      <label for="message" class="form__label">{{ $t('form.message') }}</label>
      <textarea
        id="message"
        v-model="formData.message"
        class="form__textarea"
      ></textarea>
    </div>

    <div v-if="hasErrors" class="error-fields">
      <span class="fields-with-errors" style="color: rgb(255, 0, 0); font-weight: bold;">{{ $t('form.fields-with-errors') }}:</span>
      <span v-if="errors.name">{{ $t('form.name') }},</span>
      <span v-if="errors.email">{{ $t('form.email') }},</span>
      <span v-if="errors.phone">{{ $t('form.phone') }}</span>
    </div>

    <div class="required-fields-text">{{ $t('form.required-fields') }}</div>

    <div class="center">
      <FormSendButton
        :formData="formData"
        :errors="errors"
        :isSubmitting="isSubmitting"
        :validateForm="validateForm"
        :onSuccess="handleSuccess"
        :onError="handleError"
      />
    </div>
  </form>

  <SuccessModal
    v-if="successVisible"
    :message="$t('form.success-modal')"
    @close="closeSuccessModal"
  />
</template>

<script>
import FormSendButton from "@/components/Buttons/FormSendButton.vue";
import SuccessModal from "@/components/Consultation/SuccessModal.vue";

export default {
  name: "ConsultationForm",
  components: {
    FormSendButton,
    SuccessModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
      errors: {
        name: false,
        email: false,
        phone: false,
      },
      isSubmitting: false,
      successVisible: false,
    };
  },
  computed: {
    hasErrors() {
      return Object.values(this.errors).includes(true);
    }
  },
  methods: {
    validateForm() {
      this.errors = {
        name: !this.formData.name,
        email: !this.formData.email || !/\S+@\S+\.\S+/.test(this.formData.email),
        phone: !/^\d+$/.test(this.formData.phone), 
      };
      return Object.values(this.errors).every((error) => !error);
    },
    

    formatPhone() {
      this.formData.phone = this.formData.phone.replace(/\D/g, ''); 
    },
    
    removeError(field) {
      this.errors[field] = false;
    },
    
    resetForm() {
      this.formData = { name: "", email: "", phone: "", message: "" };
      this.errors = { name: false, email: false, phone: false };
    },
    
    handleSuccess() {
      this.resetForm();
      this.$emit("formSubmitted");
    },
    
    handleError() {
      this.isSubmitting = false;
    },
  },
};
</script>






 